import { JSConn } from "@/utilities/js-conn";
import api from "@/api";
import store, { StoreActions } from "@/store";

import { CommodityInventorySummary } from "@/models/CommodityInventorySummary";

import { ilStringsToNumbers } from "@/controllers/inventoryLots";
import { scStringsToNumbers } from "@/controllers/sellContracts";

const itemDetails = {
  pluralName: "commodity_inventory_summaries",
  singularName: "commodity_inventory_summaries",
};

async function needCommodityInventorySummaries(jsConn: JSConn) {
  return api.getItems(jsConn, itemDetails).then((jsConn: JSConn) => {
    const tmpSummaries: CommodityInventorySummary[] = [...jsConn.response];

    return store.dispatch(
      StoreActions.loadCommodityInventorySummaries,
      tmpSummaries,
    );
  });
}

async function needCommodityInventorySummary(jsConn: JSConn) {
  return api.getItem(jsConn, itemDetails).then((jsConn: JSConn) => {
    const tmpSummary: CommodityInventorySummary = { ...jsConn.response };

    const tmpInventoryLots = tmpSummary.inventory_lots.map(item => {
      return ilStringsToNumbers(item);
    });

    const tmpSellContracts = tmpSummary.sell_contracts.map(item => {
      return scStringsToNumbers(item);
    });

    tmpSummary.inventory_lots = tmpInventoryLots;
    tmpSummary.sell_contracts = tmpSellContracts;

    return store.dispatch(
      StoreActions.loadCommodityInventorySummary,
      tmpSummary,
    );
  });
}

export const commodityInventorySummariesController = {
  needCommodityInventorySummaries,
  needCommodityInventorySummary,
};
